// header
$(window).on('scroll load', function () {
   const target = $('#js-change-header').offset().top - 100;
   const scroll = $(window).scrollTop();

   if (scroll > target) {
      $('.gnavi').addClass('change');
      $('.hamburger').addClass('change');
   } else {
      $('.gnavi').removeClass('change');
      $('.hamburger').removeClass('change');
   }
});


// swiper
const swiper = new Swiper('.swiper-gallery', {
   slidesPerView: 1.5,
   spaceBetween: 20,
   loop: false,
   breakpoints: {
      768: {
         slidesPerView: 3.5,
      }
   },
   navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
   },
});